// 部品 標準ボタン
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { isBrouserEdge, isBrowserIe } from '../BrowserJudgment';

interface Props {
  label: string;
  strong: boolean;
  color?: string;
  handleClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  className?: string;
  disabled?: boolean;
  show?: boolean;
}

let row_class_name = '';
const DefaultButton: React.FC<Props> = ({
  label,
  strong,
  color,
  handleClick,
  className,
  disabled,
  show,
}) => {
  // 太字
  const str = strong ? <strong>{label}</strong> : <>{label}</>;

  /**
   * ボタン色を設定する。
   * @param color ボタン色名 | undefined
   * @return string クラス名
   */
  const setButtonColor = (color: string | undefined) => {
    // 色の指定がない場合はデフォルトのボタン色を設定する。
    if (typeof color === 'undefined' || color === null) {
      return 'btn-main-color';
    }

    // 色の値に応じてボタン色を設定する。
    if (color === 'positive' || color === 'negative') {
      return `btn-${color}-color`;
    } else {
      return 'btn-main-color';
    }
  };

  if (typeof className === 'undefined') {
    // ClassNameの規定値（空文字）
    className = '';
  }
  // disabledの規定値
  if (typeof disabled === 'undefined') {
    disabled = false;
  }
  // showの規定値
  if (typeof show === 'undefined') {
    show = true;
  }

  if (show === true) {
    if (isBrowserIe()) {
      // IE
      row_class_name = 'ie-grid';
    } else if (isBrouserEdge()) {
      row_class_name = 'edge-grid';
    } else {
      // その他のブラウザ
      row_class_name = 'no-ie-grid';
    }
  } else {
    row_class_name = 'no-grid';
  }

  return (
    <Row className={`row-right-button ${row_class_name}`}>
      <Col className="text-end">
        <a className={`btn btn-xl ${setButtonColor(color)} ${className}`} onClick={handleClick}>
          {str}
        </a>
      </Col>
    </Row>
  );
};

export default DefaultButton;
